import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/weixin.png'


const _withScopeId = n => (_pushScopeId("data-v-7d0a3c0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wechat-auth-container" }
const _hoisted_2 = { class: "wechat-auth-box" }
const _hoisted_3 = { class: "wechat-auth-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "back-btn-text" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "wechat-auth-title" }
const _hoisted_7 = { class: "wechat-auth-content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wechat-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "微信"
  })
], -1))
const _hoisted_9 = { class: "wechat-auth-tips" }
const _hoisted_10 = { class: "wechat-auth-btn" }
const _hoisted_11 = { class: "wechat-auth-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "back-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.goBack && $setup.goBack(...args)))
        }, _hoisted_5),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('message.wechatdenglu')), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('message.wechatdenglutips')), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_a_button, {
            type: "primary",
            size: "large",
            onClick: $setup.handleWechatAuth,
            loading: $setup.loading
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('message.wechatshouquan')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "loading"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('message.wechatdenglufooter')), 1)
        ])
      ])
    ])
  ]))
}